import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'
import glamorous from 'glamorous'


const Item = muiThemeable()(
  glamorous.a(
    ({
      length,
      first,
      muiTheme: {
        palette: {
          borderColor,
        },
      },
    }) => ({
      paddingLeft: 'auto',
      paddingRight: 'auto',
      paddingTop: '5px',
      paddingBottom: '5px',
      display: 'inline-block',
      borderLeft: `${first ? '0px' : '1px'} solid ${borderColor}`,
      fontSize: 20,
      textAlign: 'center',
      width: `${100 / length}%`,
    }),
    ({
      isActive,
      muiTheme: {
        palette: {
          accent1Color,
        },
      },
    }) => ({
      backgroundColor: isActive ? accent1Color : '#ffffff',
      marginBottom: isActive ? -1 : 0,
    }),
  ),
)

const TextStyle = muiThemeable()(
  glamorous.span(
    ({
      muiTheme: {
        palette: {
          accent2Color,
        },
      },
    }) => ({
    }),
    ({
      isActive,
      muiTheme: {
        palette: {
          primary1Color,
          accent1Color,
          accent3Color,
          alternateTextColor,
        },
      },
    }) => ({
      color: isActive ? alternateTextColor : accent3Color,
      fontSize: 15,
    }),
  ),
)

const TabElementD = ({
  onTouchTap,
  isActive,
  tabLabel,
  first,
  length,
}) => (
  <Item
    isActive={isActive}
    onClick={onTouchTap}
    length={length}
    first={first}
  >
    <TextStyle as="span" isActive={isActive} >
      {tabLabel}
    </TextStyle>
  </Item>
)

TabElementD.propTypes = {
  onTouchTap: PropTypes.func,
  isActive: PropTypes.bool,
  tabLabel: PropTypes.string,
  length: PropTypes.number,
  first: PropTypes.bool,
}
TabElementD.defaultProps = {
  onTouchTap: () => {},
  isActive: false,
  tabLabel: '',
  length: 1,
  first: false,
}

export default TabElementD



// WEBPACK FOOTER //
// ./src/components/Tabs/ElementTabs/ElementTabD.js